import { render, staticRenderFns } from "./articl.vue?vue&type=template&id=5a425cdf&scoped=true"
import script from "./articl.vue?vue&type=script&lang=js"
export * from "./articl.vue?vue&type=script&lang=js"
import style0 from "./articl.vue?vue&type=style&index=0&id=5a425cdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a425cdf",
  null
  
)

export default component.exports